import React from 'react';
import { Bomb, Loader2 } from 'lucide-react';
import { fmt } from './wbApi';

/* Saldo de Moedas da Bruxa + botão ESTOURAR. Tudo que importa vem do servidor (saldo, custo). */
export const WbWallet = ({ me, config, busy, live, onPop, onRecharge }) => {
  const cost = Number(config?.pop_cost || 500);
  const saldo = Number(me?.balance || 0);
  const pode = saldo >= cost;
  const faltam = Math.max(0, cost - saldo);
  const porRecarga = Math.ceil(faltam / Math.max(1, Number(config?.rate_bp || 50))) * 10000;
  return (
    <div className="rounded-3xl border border-purple-800/60 bg-black/55 p-3 backdrop-blur" data-testid="wb-wallet">
      <p className="text-center text-[10px] font-black uppercase tracking-[.2em] text-purple-300/80" data-testid="wb-wallet-pops">
        {pode ? <><b className="text-lime-300">{Math.floor(saldo / cost)}</b> {Math.floor(saldo / cost) === 1 ? 'balão' : 'balões'} para estourar</>
          : <>faltam <b className="text-amber-300">{fmt(faltam)}</b> Moedas da Bruxa · <button onClick={onRecharge} className="underline decoration-amber-400/60 underline-offset-2" data-testid="wb-recharge-btn">recarregue {fmt(porRecarga)}</button></>}
      </p>
      <button onClick={onPop} disabled={!pode || busy || !live} className="wb-btn-collect mt-2 flex items-center justify-center gap-2 disabled:opacity-50" data-testid="wb-pop-btn">
        {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <Bomb className="h-5 w-5" />}
        {busy ? 'Estourando…' : !live ? 'Evento fora do ar' : pode ? `Estourar balão · ${fmt(cost)}` : `Precisa de ${fmt(cost)} Moedas da Bruxa`}
      </button>
      <p className="mt-2 text-center text-[10px] text-purple-200/70">
        A cada <b className="text-amber-300">100.000</b> moedas recarregadas você ganha <b className="text-amber-300">{fmt(100000 * Number(config?.rate_bp || 50) / 10000)}</b> Moedas da Bruxa. Prêmios de <b className="text-lime-300">{fmt(config?.prize_small)}</b> ou <b className="text-amber-300">{fmt(config?.prize_big)}</b> moedas!
      </p>
    </div>
  );
};
